import type { Point } from '../types/app.js';

export interface GlobeProjection {
  project(point: Point): { x: number; y: number } | null;
  unproject(point: { x: number; y: number }): Point | null;
  zoom(): number;
  viewKey(): string;
}

let projection: GlobeProjection | null = null;

export function setGlobeProjection(value: GlobeProjection | null): void {
  projection = value;
}

export function getGlobeProjection(): GlobeProjection | null {
  return projection;
}

export function createMapLibreProjection(map: import('maplibre-gl').Map): GlobeProjection {
  return {
    project(point) {
      const screen = map.project([point.lng, point.lat]);
      const back = map.unproject(screen);
      const delta = ((back.lng - point.lng + 180) % 360 + 360) % 360 - 180;
      if (!Number.isFinite(screen.x + screen.y) || Math.abs(back.lat - point.lat) > 0.001 || Math.abs(delta) * Math.cos(point.lat * Math.PI / 180) > 0.001) return null;
      return { x: screen.x, y: screen.y };
    },
    unproject(point) {
      const location = map.unproject([point.x, point.y]);
      const screen = map.project(location);
      if (!Number.isFinite(location.lat + location.lng) || Math.hypot(screen.x - point.x, screen.y - point.y) > 1) return null;
      return { lat: location.lat, lng: location.lng };
    },
    zoom: () => map.getZoom() + 1,
    viewKey: () => [map.getCenter().lng, map.getCenter().lat, map.getZoom(), map.getBearing(), map.getPitch(), map.getCanvas().clientWidth, map.getCanvas().clientHeight].join(','),
  };
}
